<template>
  <div class="details">
    <div class="header">
      <el-button
        type="primary"
        @click="edit"
      >
        编辑
      </el-button>
      <el-button
        @click="openDialog"
      >
        设置理论考试金额
      </el-button>
    </div>
    <info-panel :padding="24">
      <el-row>
        <el-col>
          <info-item label="理论考试须知">
            <div v-html="result.questionExamPurchaseNotice" />
          </info-item>
        </el-col>
      </el-row>
    </info-panel>
    <upsertExamFeeDialog
      :dialog-visible.sync="dialogVisible"
      :item="examFee"
      @confirm="confirm"
    />
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import infoItem from '@/components/common/infoItem.vue';
import upsertExamFeeDialog from '@/components/common/upsertExamFeeDialog.vue';
import axClient from '@/services';

export default {
  name: 'AccountDetails',
  components: {
    infoPanel,
    infoItem,
    upsertExamFeeDialog,
  },
  data() {
    return {
      result: {},
      dialogVisible: false,
      examFee: { fee: 0 },
    };
  },
  created() {
    this.getInfo();
  },
  methods: {
    // 详情
    async getInfo() {
      this.result = await axClient.config.getQuestionExamPurchaseNotice();
      this.examFee.fee = await axClient.config.getQuestionExamFee();
    },
    edit() {
      this.$router.push({ name: 'ConfigQuestionExamEdit' });
    },
    // 设置考试金额
    openDialog() {
      this.dialogVisible = true;
    },
    // 设置考试金额成功
    async confirm(fee) {
      const data = await axClient.config.upsertQuestionExamFee({ id: fee });
      if (data) {
        this.$message.success('修改成功');
        this.dialogVisible = false;
        this.getInfo();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.details {
  .header {
    display: flex;
    justify-content: flex-end;
    padding: 15px 0;
  }
}
</style>